/**
 Created by qing on 2020/5/25
 Des: 待我处理图表
 */
import BaseChart from "../BaseChart"
import {CHART_CATEGORY__TODO, CHART_TYPE__FILTER_CONTROL, CHART_TYPE__TODO_CHART} from "../types"
import {DASHBOARD_DATA_SOURCE_EXIST, SUCCESS} from "../../../src/store/types";
import Detailed from "./Detailed";

class TodoChart extends BaseChart {
  constructor() {
    super()

    this.h = 15

    this.minW = 10
    this.minH = 5

    this.showPropertiesHolder = {
      showTitle: 1
    }

    this.chartPropertiesHolder = {
      appId: '',
      flowType: "",  // todo:我的待办,flowView:流程视图
      recordId: '',
      rowLimit: -1, //数据展示数量
      showFullButton: 0,  //显示查看全部数据按钮
    }
  }

  get title() {
    return this.chartName || TodoChart._title
  }

  set title(content) {
    this.chartName = content
  }

}

TodoChart._title = '待我处理'
TodoChart.type = CHART_TYPE__TODO_CHART

TodoChart.prototype.chartCategory = CHART_CATEGORY__TODO
TodoChart.prototype.chartType = TodoChart.type
TodoChart.prototype.getValue = function () {
}

export default TodoChart
